/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/
import mutations from "@/store/auth/mutations";
import actions from "@/store/auth/actions";
import getters from "@/store/auth/getters";
import StoreAuth from "@/types/StoreAuth";

export default {
  state(): StoreAuth {
    return {
      cognitoUserName: "",
      cognitoSub: "",
      email: "",
      idToken: "",
      accessToken: "",
      refreshToken: "",
      didAutoLogout: false,
      isAuthenticated: false,
      session: null,
      givenName: "",
      familyName: "",
      stationCode: "",
      loginNumber: 0,
      companyName: "",
      threeDigitCode: "",
      country: "",
      status: "",
      area: "",
      id: 0,
      dataId: "",
      ftpUserId: "",
      title: "",
      department: "",
      userId: "",
      isSmcAdmin: false,
      isDistAdmin: false,
      isPermitAdmin: false,
      showPage: "",
      mainMenuCode: "",
      Flg: "",
      userdata: "",
      subExistMenu: null,
      subMenuList: null,
      subMenuItem: null,
      isNewsFlg: false,
      showPageTitle: "",
      pageClickCount: 0,
      showedMenuList: "",
      newsData: null,
      changePage: null,
      parentCode: "",
      groupUserId: "",
      groupLName: "",
      groupFName: "",
      groupEmail: "",
      group: "",
      stationListData: null,
      selectedStation: null,
      approvalNotice: "",
      searchedUserList: null,
      isPageLoad: true,
      pcCompanyListData: null,
      companyAdminListData: null,
      editStationData: null,
      fileFormatListData: null,
      isAltLoginAdmin: false,
      paramKDPSalesNoteList: null,
      kdpSalesNoteSearchData: null,
      kdpSalesNoteScreen: "",
    };
  },
  mutations,
  actions,
  getters,
};
